import { Button, Col, Row, Upload } from "antd";
import LabelText from "../../../../../components/input/LabelText";

import { UploadOutlined } from "@ant-design/icons";
import useUplaod from "./useUplaod";

export const Forma = () => {
  
  const {body, handleChange, handleClick, props} = useUplaod();

  ////  const url = `${URL_BASE}/api/ConcesionadosFiles`;
  return (
    <div style={{paddingRight: 10}}>
      <Row style={{ marginTop: 20 }} gutter={[10,10]}>
        <Col span={24}>
          <LabelText
            size="small"
            name="nombre"
            value={body.nombre}
            onChange={handleChange}
            label="Nombre de Archivo"
            style={{ width: "100%" }}
          />
        </Col>

        <Col span={12}>
          <div className="label">Archivo</div>
          <Upload {...props} style={{ width: "100%" }}>
            <Button style={{ width: "100%" }} size="small" icon={<UploadOutlined />}>
              Documento
            </Button>
          </Upload>
        </Col>
        <Col span={12}  style={{ marginTop: 17 }}>
          <Button style={{width: '100%'}} danger size="small" onClick={handleClick}>
            Agregar
          </Button>
        </Col>
      </Row>
      <div
        style={{ paddingLeft: 3, paddingTop: 6, height: 17, color: "orange" }}
      >
        {body.file?.name}
      </div>
    </div>
  );
};
